import { theme } from '../theme';
export const tokens = {
    StepList: {
        horizontal: {
            gap: theme.spaces.x6,
            borderBottom: theme.colors.gray200,
            background: theme.colors.transparent,
            // State-specific styles
            state: {
                disabled: {
                    color: theme.colors.gray500,
                    borderColor: theme.colors.gray300
                },
                active: {
                    borderColor: theme.colors.brand500,
                    color: theme.colors.brand700
                },
                completed: {
                    color: theme.colors.gray700,
                    borderColor: theme.colors.success500,
                    iconColor: theme.colors.success500
                },
                pending: {
                    color: theme.colors.gray500,
                    borderColor: theme.colors.gray300
                }
            },
            spacing: {
                margin: `0 0 - ${theme.spaces.x2} 0`,
                padding: `${theme.spaces.none} ${theme.spaces.x8} ${theme.spaces.x12}`
            }
        },
        vertical: {
            gap: theme.spaces.x12,
            iconSize: theme.sizes.x24,
            background: theme.colors.brand100,
            connectorColor: {
                default: theme.colors.brand300,
                featuredIcon: theme.colors.gray200
            },
            Icon: {
                boxShadow: `0 0 0 ${theme.spaces.x2} ${theme.colors.white}, 0 0 0 ${theme.spaces.x4} ${theme.colors.brand300}`,
                focusedBoxShadow: `0 0 0 ${theme.spaces.x2} ${theme.colors.white}, 0 0 0 ${theme.spaces.x4} ${theme.colors.brand600}`
            },
            // State-specific styles
            state: {
                disabled: {
                    color: theme.colors.gray500,
                    borderColor: theme.colors.gray300,
                    detailsColor: theme.colors.gray400
                },
                active: {
                    borderColor: theme.colors.brand500,
                    color: theme.colors.brand700,
                    detailsColor: theme.colors.brand600
                },
                completed: {
                    color: theme.colors.gray700,
                    borderColor: theme.colors.success500,
                    iconColor: theme.colors.success500,
                    detailsColor: theme.colors.gray600
                },
                pending: {
                    color: theme.colors.gray700,
                    borderColor: theme.colors.gray300,
                    detailsColor: theme.colors.gray600
                }
            },
            spacing: {
                gap: theme.spaces.x4,
                contentGap: theme.spaces.x2,
                defaultPadding: `${theme.spaces.x2} 0 ${theme.spaces.x24} 0`,
                featuredPadding: `0 0 ${theme.spaces.x32} 0`
            },
            connector: {
                width: theme.spaces.x2,
                radius: theme.radius.x2
            }
        }
    },
    IconSize: {
        sm: {
            fontSize: theme.sizes.x14
        },
        md: {
            fontSize: theme.sizes.x16
        }
    },
    Step: {
        verticalGap: theme.spaces.x12,
        horizontalGap: theme.spaces.x16
    },
    StepIcon: {
        radius: theme.radius.x12,
        height: theme.sizes.x24,
        width: theme.sizes.x16
    },
    Separator: {
        color: theme.colors.gray300
    }
};
